import { render, staticRenderFns } from "./indexMobile.vue?vue&type=template&id=a95fd1b4&scoped=true"
import script from "./indexMobile.vue?vue&type=script&lang=js"
export * from "./indexMobile.vue?vue&type=script&lang=js"
import style0 from "./indexMobile.vue?vue&type=style&index=0&id=a95fd1b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95fd1b4",
  null
  
)

export default component.exports